/** KayKit cosmetics — hat / cape / extra mesh toggles (no hand props). */

export type KayKitMainHandId = 'none'
export type KayKitOffHandId = 'none'

export interface AvatarEquipment {
  /** Kept for payload compat; always none (props removed). */
  mainHand: KayKitMainHandId
  offHand: KayKitOffHandId
  showHat: boolean
  showCape: boolean
  showExtra: boolean
}

export const DEFAULT_EQUIPMENT: AvatarEquipment = {
  mainHand: 'none',
  offHand: 'none',
  showHat: true,
  showCape: true,
  showExtra: true,
}

export function kaykitCosmeticMeshMatchers(characterId: string): {
  hat: string[]
  cape: string[]
  extra: string[]
} {
  if (characterId.includes('Skeleton_Warrior')) {
    return { hat: ['Helmet'], cape: ['Cloak'], extra: [] }
  }
  if (characterId.includes('Skeleton_Rogue')) {
    return { hat: ['Hood'], cape: ['Cape'], extra: [] }
  }
  if (characterId.includes('Skeleton_Minion')) {
    return { hat: [], cape: ['Cloak'], extra: [] }
  }
  if (characterId.includes('Skeleton_Mage')) {
    return { hat: ['Hat'], cape: [], extra: [] }
  }

  if (characterId.includes('Barbarian')) {
    return { hat: ['BearHat'], cape: [], extra: [] }
  }
  if (characterId.includes('Knight')) {
    return { hat: ['Helmet'], cape: ['Cape'], extra: ['HelmetVisor'] }
  }
  if (characterId.includes('Mage')) {
    return { hat: ['Hat'], cape: ['Cape'], extra: [] }
  }
  if (characterId.includes('Ranger')) {
    return { hat: [], cape: ['Cape'], extra: ['Quiver'] }
  }
  if (characterId.includes('Rogue_Hooded') || characterId.includes('RogueHooded')) {
    return { hat: [], cape: ['Cape'], extra: ['Mask'] }
  }
  if (characterId.includes('Rogue')) {
    return { hat: [], cape: ['Cape'], extra: [] }
  }
  return { hat: [], cape: [], extra: [] }
}
